<template>
	<div>
		<table class="table table-padded">
			<tbody>
			<tr class="competition_head">
				<td colspan="10"><strong>{{ msg }}</strong></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
    import ContentPlaceholder from 'vue-content-placeholder'

    export default {
        name: 'tableLoader',
	    components: {ContentPlaceholder},
        props: {
            msg: {
                default: 'Loading',
                type: String
            },
        },
        data () {
            return {
                placeholderRows:  [

                    { height: '1rem',
                        boxes: [[0, '20%'], ['2%', '15%'], ['2%', '30%'], ['20%', '8%']]
                    },

                ]
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/loader/tableLoader.vue